(function () {
  'use strict';

  function authFactory (moment, $rootScope) {
    const factory = {};

    function setDateLoaded () {
      factory.dateLoaded = moment();
    }

    function checkSessionExpiry (product) {
      let loadedDiff, sessionDiff;
      let sessionExpire = false;

      if (product) {
        // NOTE: defaults to public as of now. we have to know what other conditions or other requirements to consider
        const prodUserType = ((product.pricingInfo || {}).deliveryOptions || {}).userType || 'public';
        if ((prodUserType === 'company' && $rootScope.isNCPUser()) || (prodUserType === 'public'
          && pnTopbar.isLoggedIn && !$rootScope.isNCPUser())) {
          loadedDiff = moment().diff(factory.dateLoaded, 'minutes');
          sessionDiff = moment(pnTopbar.user.exp * 1000).diff(moment(), 'minutes');
          sessionExpire = loadedDiff >= 1 && Math.floor(sessionDiff) < 6;
        }

        if (!pnTopbar.isLoggedIn && prodUserType === 'company') {
          sessionExpire = true;
        }
      }

      return sessionExpire;
    }

    factory.setDateLoaded = setDateLoaded;
    factory.checkSessionExpiry = checkSessionExpiry;

    return factory;

  }

  angular.module('web2print.shared')
    .factory('authFactory', authFactory);
})();
